<template lang="">
    <div class="bbs_filter">
      <div class="lft_area">
        <div class="bbs_info">
          <div class="total"><strong>
            {{ getCurrentCount() }}
          </strong> / {{ this.donationGroupListCount }}</div>
        </div>
      </div>
      <div class="rgt_area">
        <div class="bbs_srch">
          <select name="" id="" class="i_sel" v-model="searchType">
            <option
              v-for="option in searchOptions"
              :value="option.value"
            >{{ option.name }}</option>
          </select>
          <input type="text" class="i_txt" name="keyword" v-model="searchWord">
          <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
        </div>
      </div>
    </div>
  
    <div class="bbs_list">
      <table class="bbs_tbl">
        <colgroup>
          <col style="width:5%">
          <col style="width:5%">
          <col style="width:20%">
          <col style="width:40%">
          <col style="width:auto">
        </colgroup>
        <thead>
          <tr>
            <th scope="col"><span class="ui_chkbox primary nontxt"><input type="checkbox" name="" @change="toggleAllCheck($event.target.checked)"><label for=""></label></span></th>
            <th scope="col">번호</th>
            <th scope="col">단체명</th>
            <th scope="col">설명</th>
            <th scope="col">등록일</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(donationGroup, index) in donationGroupList"
          >
            <td>
              <span class="ui_chkbox primary nontxt">
                <input
                  type="checkbox" 
                  :value="donationGroup.donationGroupSeq"
                  v-model="selectedDonationGroups"
                >
                <label for=""></label></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td><span class="medium">{{ $truncateText(donationGroup.groupName, 10) }}</span></td>
            <td class="subject"><a @click="toDonationGroup(donationGroup.donationGroupSeq)">{{ $truncateText(donationGroup.groupExplain, 25) }}</a></td>
            <td>{{ donationGroup.createDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <div class="paginate">
      <AdminPagination
        :totalPages = "totalPages()"
        :currentPage = "currentPage"
        @changePage = "changePage"
      />
  
      <div class="rgt_area">
        <button type="button" class="bt_base primary large_h" @click="createDonationGroup">등록</button>
        <button type="button" class="bt_base gray large_h" @click="deleteSelectedDonationGroups">삭제</button>
      </div>
    </div>
  </template>
  <script>
  import { mapActions, mapState } from 'vuex';
  import AdminPagination from '@/components/common/AdminPagination.vue';
  
  const adminDonationGroupModule = 'adminDonationGroupModule'
  
  export default {
    components: {
      AdminPagination
    },
  
    data () {
      return {
        currentPage: 1,
        selectedDonationGroups: [],
  
        searchOptions: [
          { name: '전체', value: 'all' },
        ],
        searchType: '',
        searchWord: ''
      }
    },
  
    methods: {
      ...mapActions(adminDonationGroupModule, [
        'requestDonationGroupList',
        'requestDeleteDonationGroups'
      ]),

      createDonationGroup() {
        this.$router.push({ name: "DonationGroupManageCreatePage" })
      },
  
      toDonationGroup(donationGroupSeq) {
        this.$router.push({
          name: "DonationGroupManageCreatePage",
          query: { donationGroupSeq: donationGroupSeq },
        });
      },
  
      totalPages() {
        return Math.ceil(this.donationGroupListCount / 10);
      },
  
      async changePage(page) {
        this.currentPage = page
        const {currentPage, searchType, searchWord} = this
        await this.requestDonationGroupList({currentPage, searchType, searchWord})
      },
  
      getCurrentCount() {
        const currentFirstCount = (this.currentPage - 1) * 10 + 1
        let currentLastCount = this.currentPage * 10
        if (parseInt(currentLastCount) > parseInt(this.donationGroupListCount)) {
          currentLastCount = this.donationGroupListCount
        }
        return currentFirstCount + '-' + currentLastCount
      },
  
      toggleAllCheck(isChecked) {
        if (isChecked) {
          this.selectedDonationGroups = []
          for (const donationGroup of this.donationGroupList) {
            this.selectedDonationGroups.push(donationGroup.donationGroupSeq)
          }
        } else {
          this.selectedDonationGroups = []
        }
      },
  
      async deleteSelectedDonationGroups() {
        if (this.selectedDonationGroups.length === 0) {
          alert('선택된 기부후원 단체가 없습니다');
          return;
        }
  
        const { searchType, searchWord, currentPage } = this;
        const fetchDonationGroups = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
          const params = { currentPage: page, searchType: type, searchWord: word };
          await this.requestDonationGroupList(params);
          if (isReset) {
            this.searchType = 'all';
          }
        };
  
        await this.requestDeleteDonationGroups(this.selectedDonationGroups);
        this.selectedDonationGroups = [];
  
        await fetchDonationGroups(currentPage);
  
        if (this.donationGroupList.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await fetchDonationGroups(this.currentPage);
        }
  
        if (this.donationGroupList.length === 0 || this.currentPage === 1) {
          this.currentPage = 1;
          this.searchType = '';
          this.searchWord = '';
          await fetchDonationGroups(1, '', '', true);
        }
      },
  
      async getSearch() {
        if (this.searchWord === '') {
          alert('검색어를 입력해주세요')
          return
        }
        this.currentPage = 1
        const {currentPage, searchType, searchWord} = this
        await this.requestDonationGroupList({currentPage, searchType, searchWord})
      }
    },
  
    computed: {
      ...mapState(adminDonationGroupModule, [
        'donationGroupList',
        'donationGroupListCount'
      ])
    },
  
    async mounted() {
      const {currentPage, searchType, searchWord} = this
      await this.requestDonationGroupList({currentPage, searchType, searchWord})
      this.searchType = 'all'
    }
  }
  </script>
  <style lang="">
      
  </style>